// src/services/firebase.js (SITE vitrine)
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { initializeAppCheck, ReCaptchaEnterpriseProvider } from "firebase/app-check";

// ⚠️ COPIE ici la config EXACTE de l'app "mkdstudio-website"
// (celle dont l'appId se termine par ...65aed53170412db0bdfd73)
const firebaseConfig = {
  apiKey: "AIzaSyAxagcTNG9mYws_9h0WLvKqmdRoP6pqh98",
  authDomain: "mkd-prod.firebaseapp.com",
  databaseURL: "https://mkd-prod-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "mkd-prod",
  // Vérifie la valeur dans la console Firebase. Souvent: "mkd-prod.appspot.com".
  storageBucket: "mkd-prod.firebasestorage.app",
  messagingSenderId: "392665673866",
  appId: "1:392665673866:web:65aed53170412db0bdfd73",
  measurementId: "G-BQB26R00B3",
};

// On nomme l'app "website" pour éviter tout mélange avec l'app Admin.
export const app =
  getApps().find(a => a.name === "website") ||
  initializeApp(firebaseConfig, "website");




export const appCheck = initializeAppCheck(app, {
  provider: new ReCaptchaEnterpriseProvider("6LeIzK8rAAAAADtptUfb8kV3mL776QIwj4zhUlGV"),
  isTokenAutoRefreshEnabled: true,
});

// Exports SDK
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export default app;
